import { Button } from "../common/button"
import useTranslator from "@pma/hooks/use-translator"
import { Separator } from "../common/separator"
import { useRef, useState } from "react"
import { Input } from "../common/input"
import { Label } from "../common/label"
import { Switch } from "../common/switch"
import { DictType } from "@pma/types"
import { HexColorPicker } from "react-colorful"

type Props = {
  option: "task" | "project" | "user",
  data: DictType,
  setStatus: React.Dispatch<React.SetStateAction<DictType>>
}

const UpdateStatus = ({ option, data, setStatus }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const colorPickerRef = useRef<HTMLDivElement | null>(null);
  const { translate } = useTranslator();
  return (
    <div className="space-y-2">
      <h4 className="font-semibold">
        {translate("Update")} {translate(option)} {translate("status")}
      </h4>
      <Separator />
      <div
        className="flex flex-col gap-2 w-full"
      >
        <h3 className="font-semibold text-xs">{translate("Name")}</h3>
        <Input
          placeholder={translate("Status")}
          className="w-full"
          required
          value={data.name}
          onChange={(e: any) =>
            setStatus((prev) => ({ ...prev, name: e.target.value }))
          }
          onFocus={() => setIsOpen(false)}
        />
        {option !== "user" && (
          <>
            <h3 className="font-semibold text-xs">
              {translate("Background Color")}
            </h3>
            <div className="relative">
              <Button
                className="w-full"
                style={{
                  background: data.color,
                }}
                onClick={() => setIsOpen(!isOpen)}
              />
              {isOpen && (
                <div className="absolute" ref={colorPickerRef}>
                  <HexColorPicker
                    className=""
                    color={data.color}
                    onChange={(e: any) =>
                      setStatus((prev) => ({ ...prev, color: e }))
                    }
                    onBlur={() => setIsOpen(false)}
                  />
                </div>
              )}
            </div>

            <Input
              type="text"
              pattern="^#+([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$"
              placeholder="#0000ff"
              value={data.color}
              onChange={(e: any) =>
                setStatus((prev) => ({ ...prev, color: e.target.value }))
              }
              onFocus={() => setIsOpen(false)}
            />
          </>
        )}

        {option !== "user" && (
          <div className="flex flex-col gap-3 mt-2">
            <Separator />
            <div className="flex items-center justify-between gap-2">
              <div className="flex flex-col gap-0.5">
                <Label className="text-xs font-semibold">{translate("Completion Status")}</Label>
                <span className="text-[10px] text-muted-foreground">
                  {translate("Tasks with this status will be counted as completed")}
                </span>
              </div>
              <Switch
                checked={data.finished ?? false}
                onCheckedChange={(checked: boolean) =>
                  setStatus((prev) => ({
                    ...prev,
                    finished: checked,
                    canceled: checked ? false : prev.canceled,
                  }))
                }
              />
            </div>
            <div className="flex items-center justify-between gap-2">
              <div className="flex flex-col gap-0.5">
                <Label className="text-xs font-semibold">{translate("Cancellation Status")}</Label>
                <span className="text-[10px] text-muted-foreground">
                  {translate("Tasks with this status will be counted as canceled")}
                </span>
              </div>
              <Switch
                checked={data.canceled ?? false}
                onCheckedChange={(checked: boolean) =>
                  setStatus((prev) => ({
                    ...prev,
                    canceled: checked,
                    finished: checked ? false : prev.finished,
                  }))
                }
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default UpdateStatus